module.exports = __webpack_public_path__ + "img/6.c10df137.png";